import { useEffect, useState } from "react";

type ScreenWidth = "xs" | "sm" | "md" | "lg" | "xl";

type WindowSize = {
  height: number;
  width: number;
};

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    height: window.innerHeight,
    width: window.innerWidth
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        height: window.innerHeight,
        width: window.innerWidth
      });
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const screenWidth: ScreenWidth =
    windowSize.width < 576
      ? "xs"
      : windowSize.width < 768
        ? "sm"
        : windowSize.width < 992
          ? "md"
          : windowSize.width < 1200
            ? "lg"
            : "xl";

  return {
    raw: windowSize,
    screenWidth
  };
};

export default useWindowSize;
